
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lt/sub/slapukai",
      function () {
        return require("private-next-pages/lt/sub/slapukai.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lt/sub/slapukai"])
      });
    }
  